<template>
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      clip-path="url(#a)"
    >
      <path d="M10.29 16.5c-2-2-2-4.16 0-6.13 2-1.97 4.16-2 6.13 0M10.29 8.33l4.09 4.08M8.25 10.37l3.07 3.06M18.24 6.89a1.44 1.44 0 1 0 0-2.88 1.44 1.44 0 0 0 0 2.88Z" />
      <path d="M21.7.75h-9.37a1.57 1.57 0 0 0-1.13.49l-10 10.67a1.53 1.53 0 0 0 .11 2.21l10 8.75a1.55 1.55 0 0 0 2.15-.11l9.37-10c.27-.283.42-.659.42-1.05V2.29A1.54 1.54 0 0 0 21.7.75v0Z" />
    </g>
  </svg>
</template>
